import { appBackgroundColor, grayText } from 'globals/colors';

export default {
  eventLocked: {
    margin: '15px 0 35px',
    padding: '10px',
    color: grayText,
    backgroundColor: appBackgroundColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 500,
  },
};
